<script>
	import PageSection from "../../components/PageSection.svelte";
	import PersonalDetails from "./PersonalDetails.svelte";
	import ClaimDetails from "./ClaimDetails.svelte";
	import NavigationButtons from "../../components/NavigationButtons.svelte";
	import Checkbox from "../../components/Checkbox.svelte";
	import FormRow from "../../components/FormRow.svelte";

	import { trackSubmit } from "../../analytics";
	import { pageNumber, model } from "../../stores";
	import { projectSettings } from "../../config";

	export let pageIndex = null;
	export let pageTitle = null;
	export let nextPage = null;
	export let nextPageLabel = null;
	export let previousPage = null;
	export let persistUrl = null;
	export let lastVisitedPage = null;
	export let title = null;

	let disabled = "true";

	if ($pageNumber == pageIndex + 1) {
		alert("Your registration has already been submitted.");
		window.location.href = window.basePath;
	} else {
		$pageNumber = pageIndex;
	}

	$model.LastPageVisited = lastVisitedPage;
	document.title = pageTitle;

	const onSubmit = () => {
		trackSubmit(projectSettings.classActionName);
	};

	let confirmed = false;
</script>

{#if $pageNumber == pageIndex}
	<PageSection>
		<h1>Confirmation</h1>
		<p>
			Please review the information you have provided and confirm the information is true and correct by clicking
			the checkbox below.
		</p>
		<p>
			If you need to edit any of your answers, please do so by clicking the 'Previous' button at the bottom of the
			page.
		</p>

		<PersonalDetails {disabled}></PersonalDetails>
		<ClaimDetails {disabled}></ClaimDetails>

		<FormRow>
			<p>
				By registering with us, you are signing up to receive updates on our investigation into a potential
				class action regarding PFAS contamination of groundwater affecting properties surrounding various
				airports throughout Australia. Registering with us does not establish a solicitor client legal
				relationship with Shine Lawyers. No court proceedings have been filed and we may ultimately, after
				investigations have concluded, decide not to proceed with the case. As we have not entered into a
				solicitor client retainer with you at this time, any rights you may have are not presently protected.
				 Statutory time limits may also apply to your claim. If you have any concerns about your potential
				claim, please seek independent legal advice immediately.
			</p>
		</FormRow>

		<FormRow>
			<div class="col-md-8 col-sm-12">
				<Checkbox
					required="true"
					bind:checked={confirmed}
					label="I confirm that all information provided in this section is true and correct."
					id="confirmation"
				></Checkbox>
			</div>
		</FormRow>

		<div class="form-row">
			<div class="col-md-12 last">
				<NavigationButtons
					{persistUrl}
					{previousPage}
					{nextPage}
					{nextPageLabel}
					{onSubmit}
					pageName={title}
					tealiumTag={true}
				></NavigationButtons>
			</div>
		</div>
	</PageSection>
{/if}

<style>
	p {
		font-size: medium !important;
	}
</style>
